import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  createWebHashHistory,
} from "vue-router";
import IndexView from "@/views/IndexView.vue";
import naPageView from "@/views/404View.vue";
import store from "@/store";
import routerList from "./routerList";
import { updatePageMeta } from "@/utils/SeoUtil";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/404",
    name: "404",
    meta: { title: "404", noSearch: true },
    component: naPageView,
  },
  {
    path: "/error",
    name: "error",
    meta: { noSearch: true },
    component: naPageView,
    props: true, //參數會自動轉成props
  },
  {
    path: "/:pathMatch(.*)*",
    name: "403",
    meta: { noSearch: true },
    component: naPageView,
  },
];

const router = createDefRouter();

const menuList = createRoutes(store.getters["menu/getMenu"]);
menuList.forEach(function (route) {
  router.addRoute(route);
});

const homeName = "Home";
let hasMenu = false;

router.beforeEach((to, from, next) => {
  const meta = to.meta;
  const toPath = to.path;

  if (toPath === "/") {
    return next({
      name: homeName,
    });
  }

  // 動態更新瀏覽器頁簽標題與所有 SEO Meta 標籤 (TDK, Open Graph, Canonical)
  updatePageMeta(to);

  store.commit("menu/setMenuActive", meta.active ? meta.active : "");
  store.commit("menu/setHash", to.hash);
  return next();
});

function createDefRouter() {
  return createRouter({
    history: createWebHistory(process.env.VUE_APP_AP_NAME),
    // 因為放在Cloud Storage上直接讀檔案,所以要用HASH模式(#帶參數)
    //history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.name == from.name || to.params["section"] != null) {
        return false;
      } else {
        // 總是滾動到頂部
        return { top: 0 };
      }
    },
  });
}

export function resetRouter() {
  //homePath = "" ;
  hasMenu = false;
  const routeList = router.getRoutes();
  routeList.forEach(function (route) {
    router.removeRoute(route.name);
  });
  routes.forEach(function (route) {
    router.addRoute(route);
  });
}

function createRoutes(menuObj) {
  const result: Array<RouteRecordRaw> = [];
  const children = [];

  result.push({
    path: "/",
    name: "/",
    component: IndexView,
    children,
  });

  routerList.routerList.forEach((item) => {
    generateRoutes(children, item);
  });

  return result;
}

function generateRoutes(children, item) {
  if (item.hasOwnProperty("path")) {
    if (item.children) {
      const child = [];
      item.children.forEach((e) => {
        generateRoutes(child, e);
      });
      item.children = child;
    }
    if (item.checkName) {
      item.beforeEnter = (to, from, next) => {
        if (item.checkName.indexOf(from.name) < 0) {
          next({ name: item.checkName[0] });
        } else {
          next();
        }
      };
    }
    children.push(item);
  } else if (item.functionId) {
    const functionId = item.functionId;
    const routerObj = routerList[functionId];
    if (routerObj) {
      /*if( homePath === "" ) {
        homePath = routerObj.path.split(":")[0] ;
      }*/
      generateRoutes(children, routerObj);
    } else {
      if (item.children) {
        item.children.forEach((e) => {
          generateRoutes(children, e);
        });
      }
    }
  } else if (item.children) {
    item.children.forEach((e) => {
      generateRoutes(children, e);
    });
  }
}

if (typeof window !== "undefined") {
  (window as any).__ROUTER__ = router;
}

export default router;
